import Vue from 'vue'
import Vuex from 'vuex'
import orderApi from '@/axios/order'
import zhugeObj from '@/assets/js/track'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    keFuTel: '4000520618',
    token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
    locationCity : '',
    routerIndex : 0,
    serviceUrl : window.location.origin,
    servicePhone : localStorage.getItem('servicePhone') ? localStorage.getItem('servicePhone') : '',
    customerId : localStorage.getItem('customerId') ? localStorage.getItem('customerId') : '',
    source : '',
    publicButton:new Map([
      ['1','我要下单'],
      ['2','收费标准'],
      ['3','包邮地区'],
      ['4','历史案例'],
      ['5','会员充值'],
      ['6','我要反馈'],
      ['7','关于包拯'],
      ['8','我的订单']
    ]),
    takeSendNum : 99,
    takeSendCity : '北京、天津、上海、广州、深圳、成都、杭州、重庆、苏州、武汉、南京、郑州、长沙、东莞、青岛、沈阳、合肥、昆明、厦门、无锡、济南、福州、温州、大连、西安、佛山、中山、台州、泉州、石家庄、南通、太原、徐州、长春、珠海、惠州、宁波、潍坊、南昌、金华、烟台、哈尔滨、绍兴、临沂、贵阳、唐山、常州、兰州、洛阳、榆林、襄阳、济宁、宜昌、镇江、芜湖、遵义、赣州、淮安、南阳、泰州、南宁、嘉兴、鄂尔多斯、扬州、漳州、岳阳、淄博、沧州、邯郸、常德、菏泽、衡阳、九江、连云港、保定、宿迁、茂名、许昌、湖州、江门、湛江、廊坊、周口、德州、威海、东营、株洲、柳州、曲靖、盐城、滁州、绵阳、包头、新乡、宜春、宁德、海口、三亚、呼和浩特'
  },
  mutations: {
    setUserInfo (state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    setLocationCity(state,locationCity){
      state.locationCity = locationCity
    },
    setrouterIndex(state,router){
      state.routerIndex = state.routerIndex + 1
    },
    setServicePhone(state,servicePhone){
      state.servicePhone = servicePhone;
      localStorage.setItem('servicePhone', servicePhone)
    },
    setCustomerId(state,customerId){
      state.customerId = customerId;
      localStorage.setItem('customerId', customerId)
    },
    setUoPageId(state,pageNum,bzSource){
      let {publicButton} = state
      zhugeObj.track({
        title : '包拯H5-曝光',
        content: {
          '来源按钮': publicButton.get(pageNum),
          'BZsource':bzSource
        }
        
      })
    },
    setSource(state,source){
      let souceObj = {
        'douyin' : '抖音',
        'wechat' : '公众号',
        'share' : '链接分享',
        '1' : '短信链接(1-1)',
        '2' : '短信链接(1-2)',
        '3' : '短信链接(1-3)',
        '4' : '短信链接(2-1)',
        '5' : '短信链接(2-2)',
        '6' : '短信链接(2-3)',
        '7' : '短信链接(3-1)',
        '8' : '短信链接(3-2)',
        '9' : '短信链接(3-3)',
        '10' : '服务号文章',
        '11' : '包拯朋友圈(1-1)',
        '12' : '陈真朋友圈(1-1)',
        '13' : '官网',
        '14' : '包拯朋友圈(1-2)',
        '15' : '包拯朋友圈(1-3)',
        '16' : '包拯朋友圈(1-4)',
        '17' : '包拯朋友圈(1-5)',
        '18' : '包拯朋友圈(1-6)',
        '19' : '陈真朋友圈(1-2)',
        '20' : '陈真朋友圈(1-3)',
        '21' : '陈真朋友圈(1-4)',
        '22' : '陈真朋友圈(1-5)',
        '23' : '陈真朋友圈(1-6)',
      }

      zhugeObj.track({
        title : souceObj[source]
      })

      state.source = source;

    }
  },
  actions:{
     
  }
})
